const dropdownPaths = {
  en: {
    adminHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/admin/dashboard',
    },
    ownerHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/owner/dashboard',
      bookings: 'Bookings',
      bookingsHref: '/owner/bookings',
      feedback: 'Feedback',
      feedbackHref: '/owner/feedbacks',
      yourPayments: 'Payments',
      yourPaymentsHref: '/owner/economics',
      travelDocuments: 'Documents',
      travelDocumentsHref: '/owner/documents',
    },
    customerHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/customer/dashboard',
      villages: 'Villas',
      villagesHref: '/customer/villas',
      experiences: 'Experiences',
      experiencesHref: '/customer/experiences',
      yourPayments: 'Your Payments',
      yourPaymentsHref: '/customer/payments',
      travelDocuments: 'Travel Documents',
      travelDocumentsHref: '/customer/travel-documents',
      planYourTrip: 'Plan Your Trip',
      planYourTripHref: '/customer/plan-your-trip',
      profile: 'Profile',
      profileHref: '/customer/profile',
    },
  },
  it: {
    adminHrefs: {
      dashboard: 'Bacheca',
      dashboardHref: '/admin/dashboard',
    },
    ownerHrefs: {
      dashboard: 'Bacheca',
      dashboardHref: '/owner/dashboard',
      bookings: 'Prenotazioni',
      bookingsHref: '/owner/prenotazioni',
      feedback: 'Recensioni',
      feedbackHref: '/owner/feedbacks',
      yourPayments: 'Pagamenti',
      yourPaymentsHref: '/owner/pagamenti',
      travelDocuments: 'Documenti',
      travelDocumentsHref: '/owner/documenti',
    },
    customerHrefs: {
      dashboard: 'Bacheca',
      dashboardHref: '/it/customer/dashboard',
      villages: 'Ville',
      villagesHref: '/it/customer/ville',
      experiences: 'Esperienze',
      experiencesHref: '/it/customer/esperienze',
      yourPayments: 'I Tuoi Pagamenti',
      yourPaymentsHref: '/it/customer/pagamenti',
      travelDocuments: 'Documenti Di Viaggio',
      travelDocumentsHref: '/it/customer/documenti-viaggio',
      planYourTrip: 'Organizza Il Viaggio',
      planYourTripHref: '/it/customer/organizza-viaggio',
      profile: 'Profilo',
      profileHref: '/it/customer/profilo',
    },
  },
  de: {
    adminHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/admin/dashboard',
    },
    ownerHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/owner/dashboard',
      bookings: 'Bookings',
      bookingsHref: '/owner/bookings',
      feedback: 'Feedback',
      feedbackHref: '/owner/feedbacks',
      yourPayments: 'Payments',
      yourPaymentsHref: '/owner/economics',
      travelDocuments: 'Documents',
      travelDocumentsHref: '/owner/documents',
    },
    customerHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/de/customer/dashboard',
      villages: 'Villen',
      villagesHref: '/de/customer/villen',
      experiences: 'Aktivitäten',
      experiencesHref: '/de/customer/erfahrungen',
      yourPayments: 'Ihre Zahlungen',
      yourPaymentsHref: '/de/customer/payments',
      travelDocuments: 'Reisedokumente',
      travelDocumentsHref: '/de/customer/travel-documents',
      planYourTrip: 'Planen Sie Ihre Reise',
      planYourTripHref: '/de/customer/plan-your-trip',
      profile: 'Profil',
      profileHref: '/de/customer/profile',
    },
  },
  fr: {
    adminHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/admin/dashboard',
    },
    ownerHrefs: {
      dashboard: 'Dashboard',
      dashboardHref: '/owner/dashboard',
      bookings: 'Bookings',
      bookingsHref: '/owner/bookings',
      feedback: 'Feedback',
      feedbackHref: '/owner/feedbacks',
      yourPayments: 'Payments',
      yourPaymentsHref: '/owner/economics',
      travelDocuments: 'Documents',
      travelDocumentsHref: '/owner/documents',
    },
    customerHrefs: {
      dashboard: 'Tableau de bord',
      dashboardHref: '/fr/customer/dashboard',
      villages: 'Villas',
      villagesHref: '/fr/customer/villas',
      experiences: 'Expériences',
      experiencesHref: '/fr/customer/experiences',
      yourPayments: 'Vos paiements',
      yourPaymentsHref: '/fr/customer/payments',
      travelDocuments: 'Documents de Voyage',
      travelDocumentsHref: '/fr/customer/travel-documents',
      planYourTrip: 'Planifier votre voyage',
      planYourTripHref: '/fr/customer/plan-your-trip',
      profile: 'Profil',
      profileHref: '/fr/customer/profile',
    },
  },
};

export default dropdownPaths;
